<div *transloco="let translate" fxFlex="100" fxLayout="column" fxLayoutAlign="center center">
  <rmb-empty-page
    image="/assets/images/undraw_cancel_7zdh.svg"
    [title]="translate('confirmation.accessDenied.title')"
    [subtitle]="translate('confirmation.accessDenied.text')"
  ></rmb-empty-page>
</div>
